import FeatureController from '../FeatureController';

export default class AppController extends  FeatureController
{
    constructor (panel, $state, $location) {
        super(panel, $state);
        this.$location = $location;
        this.isLoading = true;
        this.data = {};

        this.auth = {};

        this.loggedIn = this.panel.isLoggedIn();

        this.login_error = '';

        this.register = {data:{sex:'male',country:'US'}};

        this.countries = {};

        this.staticPages = [];

        this.signupSubmitted = false;

        this.useRecaptcha = false;

        this.required = ['screen_name','email','password','sex','country','postal_code'];

        const self = this;

        if (this.useRecaptcha) {
            window.reCaptureSignin = (captcha) => {
                self.captcha = captcha;
                self.signup();
            };

            this.panel.loadCaptcha();
        }

        let form = $(".start-page-register-form");

        form.attr("autocomplete", "off");

        this.panel.registerEvent(panel.event.LOGGED_IN, (e) => {
            self.loggedIn = true;
            self.init(e);
            },
            false
        );

        this.panel.registerEvent(panel.event.LOGGED_OUT, (e) => {
            self.sessionDestroy(true);
            },
            false
        );

        this.init();

        if (!self.panel.isLoggedIn()) {
          this.panel.get('/v1/pages/list', (response) => {
            self.isLoading = false;
            if (self.panel.okay(response)) {
              self.staticPages = response.data;
            }
          }, (response) => {
            self.isLoading = false;
          });

          this.panel.get('/v1/data/countries', (response) => {
            if (panel.okay(response)) {
              self.countries = response.data.countries;
            }
          });
        } else {
          this.panel.xy();
          self.isLoading = false;
        }
    }

    init (isLoggedIn) {
        isLoggedIn = this.loggedIn ? true : isLoggedIn;

        if (isLoggedIn) {

          this.register = this.panel.getUser();

          if (this.$location.$$path === '/' && isLoggedIn) {
              this.loggedIn = true;
              history.pushState(null, 'Home', '/home');
          }
        }
    }

    sessionDestroy (e) {

    }

    isNavigationAllowed()
    {
      if (!this.panel.hasCompletedProfile() || !this.panel.hasCompletedMatch()) {
        return false;
      }

      return true;
    }

    validateSignup () {

        let form = $(".start-page-register-form");

        let errors = [];

        let div_errors = form.find('div.error');

        for (let i in div_errors) {
            let val = div_errors[i].innerHTML;
            if (val !== '' && val !== undefined) {
                errors.push(val);
            }
        }

        let validated = true;

        for (let i = 0 ; i < this.required.length ;  i++) {
            let item = this.required[i];
            if(typeof this.register.data[item] === 'undefined' || this.register.data[item].trim() === ''){
                validated = false;
                let eventName = $('.register-'+item).attr('listen');
                if (eventName) {
                    this.panel.emitEvent(eventName, {item:item, message: 'Please enter a valid '+item.replace('_', ' ')});
                }
            }
        }

        if (validated) {
            let signup = true;
            if (this.useRecaptcha) {
                grecaptcha.execute();
                if (!this.captcha) {
                    this.captcha = grecaptcha.getResponse();
                    if (!this.captcha) {
                        signup = false;
                        $('#google-recaptcha').trigger('click');
                    }
                }
            }

            if (signup) this.signup();
        }
    }

    signup () {
        if (this.signupSubmitted === false) {
            this.signupSubmitted = true;

            if ($('.signup-user-btn').find('.signup-spinner')) {
                $('.signup-spinner').remove();
            }

            $('.signup-user-btn').append($("<span class='signup-spinner'>&nbsp;<i class='fa fa-refresh fa-spin fa-fw'></i></span>"));

            const self = this;

            this.panel.post('/v1/account/signup', {signup:this.register.data, captcha:this.captcha}, (response) => {

                self.signupSubmitted = false;

                $('.signup-spinner').remove();

                if (self.panel.okay(response)) {
                  self.auth = {username:self.register.data.screen_name, password:self.register.data.password};
                  self.login();
                }
                else {
                  self.captcha = false;
                  if (response.message) {
                      self.panel.alert(response.message);
                  }
                  else {
                      self.panel.alert('An unknown error occurred. Please try again.');
                  }
                }
            }, (err) => {
                self.signupSubmitted = false;

                $('.signup-spinner').remove();

                console.log(err.data);

                for (let i = 0 ; i < self.required.length ;  i++) {
                    let item = self.required[i];
                    if (err.data[item]) {
                        let eventName = $('.register-'+item).attr('listen');
                        if (eventName) {
                            this.panel.emitEvent(eventName, {item:item, message: err.data[item]});
                        }
                    }
                }
            });
        }
    }

    toggleLogin () {
        let form = $('.login-form');
        if (form.hasClass('show')) {
            form.slideUp();
            form.removeClass('show');
        } else {
            form.addClass('show');
            form.slideDown();
        }
    }

    login () {
      let loginBtn = $('.login-signin-btn');
      loginBtn.append($("<span class='login-spinner'>&nbsp;<i class='fa fa-refresh fa-spin fa-fw'></i></span>"));

      const self = this;

      this.panel.post('/v1/account/login', this.auth, (response) => {

        $('.login-spinner').remove();

        if (self.panel.okay(response)) {
          self.panel.login(response.auth_token);
        }
        }, (err) => {
          self.login_error = err.data.message;
          if (loginBtn.find('.login-spinner')) $('.login-spinner').remove();
      });
    }

    logout () {
        let logoutURL = "/v1/account/logout";
        let isSocial = !!this.register.facebook_id;
        const self = this;
        this.panel.post(logoutURL, {}, (response) => {
            self.panel.logout(response);
        })
    }

    recover () {

        $('.reset-pass-btn').append($("<span class='reset-spinner'>&nbsp;<i class='fa fa-refresh fa-spin fa-fw'></i></span>"));

        const self = this;

        if (!this.data.email) return;

        this.panel.post('/v1/account/recover', {email:this.data.email}, (response) => {

            $('.reset-spinner').remove();

            self.panel.alert(response.message);
        });
    }

    reset () {

        $('.reset-pass-btn').append($("<span class='reset-spinner'>&nbsp;<i class='fa fa-refresh fa-spin fa-fw'></i></span>"));

        this.panel.post('/v1/account/reset', this.data, (response) => {

            $('.reset-spinner').remove();

            let msg = response.message;

            if(self.panel.okay(response)) msg = msg + "<br>Redirecting in <span class='redirect-timer'></span>";

            this.panel.alert(msg);

            if(self.panel.okay(response)){
                let secs = 4;
                let y = setInterval(() => {
                    secs = secs - 1;
                    $('.redirect-timer').html(secs);
                    if(secs == 0){
                        clearInterval(y);
                        window.location = '/';
                    }
                }, 1000);
            }

        });
    }

    toggleMenu () {
        let size = $("#left-menu").width();

        let form = $('#global-menu');

        if (form.hasClass('show')) {

            form.removeClass('show');

            form.animate({'left': (size + size) * -1 + 'px'}, 400);/*'easeOutBack'*/
        } else {

            form.addClass('show');

            form.animate({'left': 0 + 'px'}, 400);//, 'easeOutQuint'
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/features/index/AppController.js